import { render, staticRenderFns } from "./PDFComponent.vue?vue&type=template&id=767207c4&scoped=true"
import script from "./PDFComponent.vue?vue&type=script&lang=js"
export * from "./PDFComponent.vue?vue&type=script&lang=js"
import style0 from "./PDFComponent.vue?vue&type=style&index=0&id=767207c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767207c4",
  null
  
)

export default component.exports